import React, { useEffect, useState, useContext, forwardRef, useRef } from 'react';
import './Components.css';
import Select from 'react-select';
import { DndContext, PointerSensor, closestCenter, useSensor, useSensors } from '@dnd-kit/core';
import { SortableContext, arrayMove, useSortable, verticalListSortingStrategy } from '@dnd-kit/sortable';
import { getCategories, getFamiliesByCategoryId, getProducts, getFamilies, getLofts, getShaftsByFamily, getFamilyFromFamilyId } from '../productData/products';
import { connect_sensor, disconnect_sensor, session_update } from '../mobile/mobileHandler';
import { ClubManufacturers, DefaultClubLofts } from '../productData/clubData';
import { AppContext, ViewOnlyContext } from '../contexts/AppContext';
import Collapsible from 'react-collapsible';
import { detectDeviceType, detectOrientation } from '../utils/Utilities';
import { Cross2Icon } from '../icons/Icons';
import { GetCurrentSession, SelectSessionSetup, CheckAllSessionSetup, CheckSessionSetup } from '../isdlData/sessionData';

function createBallSeriesItem(name = '') {
    const cryptoApi = typeof window !== 'undefined' ? window.crypto : null;
    return {
        id: (cryptoApi?.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2)}`),
        name
    };
}

function SortableBallSeriesItem({ item, index, textAlign, onRename, onDelete, DeleteSeriesIcon }) {
    const { attributes, listeners, setNodeRef, transform, transition } = useSortable({ id: item.id });
    const style = {
        transform: transform ? `translate3d(${transform.x}px, ${transform.y}px, 0)` : undefined,
        transition,
        width: "100%"
    };

    return (
        <div ref={setNodeRef} style={style}>
            <div className='ball-series-item'>
                <button
                    type="button"
                    {...attributes}
                    {...listeners}
                    style={{ width: "32px", height: "40px", background: "transparent", border: "0px", cursor: "grab", color: "inherit" }}
                    aria-label={`Drag group ${index + 1}`}
                >
                    ≡
                </button>
                <div style={{ width: "100%", alignContent: "center", textAlign }}>
                    <span style={{ marginRight: "8px" }}>{index + 1}:</span>
                    <input
                        className="input"
                        type="text"
                        value={item.name}
                        onChange={(e) => onRename(item.id, e.target.value)}
                        style={{ width: "calc(100% - 36px)" }}
                    />
                </div>
                <button
                    style={{ width: "40px", height: "40px", background: "transparent", border: "0px", padding: "0px", alignContent: "center" }}
                    onClick={() => onDelete(item.id)}
                >
                    <DeleteSeriesIcon />
                </button>
            </div>
        </div>
    );
}

const NewSetup = forwardRef(({setModalState, addNewSetup, addMultipleNewSetups}, ref) => {


    const [newSetupOpen, setNewSetupOpen] = useState(false);

    const [manufacturers, setManufacturers] = useState([]);
    const [selectedManufacturer, setSelectedManufacturer] = useState('');

    const [categories,setCategories] = useState([]);
    const [categoriesData,setCategoriesData] = useState([]);
    const [selectedCategory,setSelectedCategory] = useState(null);
    const [catLoading, setCatLoading] = useState(true);
    const [preSelectedCategory, setPreSelectedCategory] = useState(null);
    const categoryInput = useRef(null);
    

    const [clubs,setClubs] = useState([]);
    const [clubsData,setClubsData] = useState([]);
    const [selectedClub,setSelectedClub] = useState(null);
    const [clubLoading, setClubLoading] = useState(true);
    const [preSelectedClub, setPreSelectedClub] = useState(null);
    const clubInput = useRef(null);

    const [lofts, setLofts] = useState([]);
    const [selectedLoft, setSelectedLoft] = useState("");
    const [preSelectedLoft, setPreSelectedLoft] = useState("");
    const loftInput = useRef(null);

    const [prototypeId,SetPrototypeId] = useState("");
    const [validPrototypeId, setValidPrototypeId] = useState(false);
    const prototypeInput = useRef(null);

    const [clubDescription,setClubDescription] = useState("");
    const clubDescriptionInput = useRef(null);

    const [customName, setCustomName] = useState("");
    const customInput = useRef(null);

    const [clubId, setClubId] = useState("");
    const clubIdInput = useRef(null);

    const [shaftLoading, setShaftLoading] = useState(true);
    const [shafts, setShafts] = useState([]);
    const [shaftData, setShaftData] = useState([]);
    const [selectedShaft, setSelectedShaft] = useState("");
    const [preSelectedShaft, setPreSelectedShaft] = useState(null);
    const [selectedShaftData, setSelectedShaftData] = useState(null);

    const [preLoadedData, setPreloadedData] = useState(false);
    const [cocoonId, setCocoonId] = useState("");

    const [balls,setBalls] = useState([]);
    const [ballsData,setBallsData] = useState([]);
    const [selectedBall,setSelectedBall] = useState(null);
    const [ballLoading, setBallLoading] = useState(true);
    const [preSelectedBall, setPreSelectedBall] = useState({value:"0", label:"None"});

    const [ballPrototypeId,SetBallPrototypeId] = useState("");
    const [ballCustomName,SetBallCustomName] = useState("");
    const ballPrototypeInput = useRef(null);
    const ballCustomInput = useRef(null);

    const [useBallSeries, setUseBallSeries] = useState(false);
    const [ballSeries,setBallSeries] = useState([]);
    const ballSeriesNumberInput = useRef(null);
    const ballSeriesContainer = useRef(null);
    const [ballSeriesCount, setBallSeriesCount] = useState(null);
    const [withTeeCheckbox, setWithTeeCheckbox] = useState(false);
    const [wedgeShotType, setWedgeShotType] = useState("");
    const [validSetup, setValidSetup] = useState(false);

    const { viewOnly } = useContext(ViewOnlyContext);

    const [isMobile, setIsMobile] = useState(detectDeviceType() === "Mobile");
    const [orientation, setOrientation] = useState(detectOrientation());
    const sensors = useSensors(useSensor(PointerSensor, { activationConstraint: { distance: 5 } }));


    useEffect(() => {
        const initializeProductData = async () => {

            setManufacturers(ClubManufacturers.map(cb => ({value: cb, label: cb})));
            setSelectedManufacturer({value: ClubManufacturers[0], label: ClubManufacturers[0]});
      
            let initCatData = await initCategoryData();
            setCategories(initCatData);
            setCatLoading(false);
            let balls = await initBallData();
            setBallsData(balls);
            setBalls(balls.map(ba => ({value: ba.FamilyId, label: ba.Name })));//build club list
            setBallLoading(false);

            const loadJSON = sessionStorage.getItem("NewSetupSavedData") ? sessionStorage.getItem("NewSetupSavedData") : "{}";
            const loadData = JSON.parse(loadJSON);

            if(selectedBall === null && (!loadData.hasOwnProperty('ball') || loadData.hasOwnProperty('ball') && loadData.ball === '')){
                setSelectedBall(balls[0]);
            }
            };
      
            connect_sensor();

            window.addEventListener('sensorConnectResponse', connectResponse);

            initializeProductData();

            return () => {
                window.removeEventListener('sensorConnectResponse', connectResponse);
            }
      }, []);

      

      useEffect(() => {
        const loadClubsForCategory = async () =>{
            
            setPreSelectedCategory(selectedCategory);
            // let selCat = await doSelectCategory(category);
            setClubLoading(true);
            let clubs = await initClubData(selectedCategory.value);

            if(selectedBall?.FamilyId === "BALLSERIES"){
                clubs.unshift({
                    id:"NONE",
                    Name:"None",
                    FamilyId:"NONE",
                    CategoryId:selectedCategory.value,
                    Category:selectedCategory.label,
                    isPrototype:false
                });
            }

            setClubs(clubs.map(cl => ({value: cl.FamilyId, label: cl.Name })));//build club list
            setClubsData(clubs);
            setClubLoading(false);

            if(selectedClub != null && ClubIsCustomOrPrototype(selectedClub)){
                setSelectedLoft(null);
                setPreSelectedLoft(null);
                await initLofts(selectedClub);
            }
        }
        
        if(selectedCategory != null && !preLoadedData){
            loadClubsForCategory();
        }
        if (selectedCategory?.label === "Putters") {
        setWithTeeCheckbox(false);
        }
        if (selectedCategory?.label === "Wedges") {
        setWedgeShotType(false);
        }
        if (selectedCategory != null && ["Woods", "Hybrids"].includes(selectedCategory.label)) {
        setWithTeeCheckbox(true);
        } else {
        setWithTeeCheckbox(false);
        }
      }, [selectedCategory, selectedBall]);

      useEffect(() => {
        const finishClubSelected = async () => {
            await initLofts(selectedClub);
            if(selectedBall?.FamilyId === "BALLSERIES" && selectedClub?.FamilyId === "CUSTOM"){
                const defaultLoft = {value:"8 °", label:"8 °"};
                setSelectedLoft(defaultLoft);
                setPreSelectedLoft(defaultLoft);
            }
            //build shafts here
            if(!ClubIsCustomOrPrototype(selectedClub)){
                setShaftLoading(true);
                let shafts = await getShaftsByFamily(selectedClub.FamilyId);
                shafts = shafts ? shafts : [{Id:'-1', Description:'No shaft available'}];
                AddShaftsToData(shafts);
                setShafts(shafts.map(shaft => ({value: shaft.Id, label: shaft.Description})));
                setShaftLoading(false);
            }
        }

        if(selectedClub != null && !preLoadedData){
            finishClubSelected();
        }

        LoadSelectionClubOptions();

      }, [selectedBall, selectedClub]);

      useEffect(() => {//validation

        let valid = true;

        if(selectedCategory === null || selectedCategory === undefined){
            valid = false;
            invalidatedField(categoryInput, false);
        }else{
            invalidatedField(categoryInput, true);
        }

        if((selectedClub === null || selectedClub === undefined) && selectedCategory){
            valid = false;
            invalidatedField(clubInput, false);
        }else{
            invalidatedField(clubInput, true);
        }

        if(loftInput.current){
            if((selectedLoft === null || selectedLoft === undefined || selectedLoft === '') && selectedClub){
                valid = false;
                invalidatedField(loftInput, false);
            }else{
                invalidatedField(loftInput, true);
            }
        }

        if(prototypeInput.current && selectedClub.FamilyId === "PROTOTYPE"){
            if(!validPrototypeId){
                valid = false;
                invalidatedField(prototypeInput, false);
            }else{
                invalidatedField(prototypeInput, true);
            }

            if(clubDescription === ""){
                valid= false;
                invalidatedField(clubDescriptionInput, false);
            }else{
                invalidatedField(clubDescriptionInput, true);
            }
        }

        if(customInput.current && selectedClub.FamilyId === "CUSTOM"){
            if(customName === ""){
                valid = false;
                invalidatedField(customInput, false);
            }else{
                invalidatedField(customInput, true);
            }
        }

        if(clubIdInput.current){
            if(clubId === ""){
                valid = false;
                invalidatedField(clubIdInput, false);
            }else{
                invalidatedField(clubIdInput, true);
            }
        }

        if(ballPrototypeInput.current && selectedBall.FamilyId === "PROTOTYPE"){
            if(ballPrototypeId === ""){
                valid = false;
                invalidatedField(ballPrototypeInput, false);
            }else{
                invalidatedField(ballPrototypeInput, true);
            }
        }

        if(ballCustomInput.current && selectedBall.FamilyId === "CUSTOM"){
            if(ballCustomName === ""){
                valid = false;
                invalidatedField(ballCustomInput, false);
            }else{
                invalidatedField(ballCustomInput, true);
            }
        }

        if(ballSeriesContainer.current && useBallSeries){
            if(ballSeries && ballSeries.length === 0){
                valid = false;
                invalidatedField(ballSeriesContainer, false);
            }else{
                invalidatedField(ballSeriesContainer, true);
            }
        }

        if(ballSeriesNumberInput.current && useBallSeries){
            if(ballSeriesCount && !isNaN(ballSeriesCount)){
                invalidatedField(ballSeriesNumberInput, true);
            }else{
                valid = false;
                invalidatedField(ballSeriesNumberInput, false);
            }
        }

        setValidSetup(valid);

      }, [selectedManufacturer, selectedCategory, selectedClub, selectedLoft, selectedShaft, 
        selectedBall, prototypeId, customName, clubId, ballPrototypeId, ballCustomName, ballSeries, 
        useBallSeries, ballSeriesCount, clubDescription]);
    
        useEffect(() => {
            const handleResize = () => {
                setOrientation(detectOrientation());
                };

            setIsMobile(detectDeviceType() === "Mobile");
            window.addEventListener('resize', handleResize);
            return () => {
                window.removeEventListener('resize', handleResize);
                };
            }, []);

    const [initLoad, setInitLoad] = useState(false);
    const [initLoadClub, setInitLoadClub] = useState(false);
    const [initLoadBall, setInitLoadBall] = useState(false);
    const [initLoadLoft, setInitLoadLoft] = useState(false);
    const [initLoadShaft, setInitLoadShaft] = useState(false);

        //start of loading data
        useEffect(()=> {
            if( !initLoad &&
                manufacturers && manufacturers.length > 0 && 
                categories && categories.length > 0 &&
                balls && balls.length > 0){
                LoadSelectionInit();
                setInitLoad(true);
            }
        }, [manufacturers, categories, balls]);

        //load club
        useEffect(()=> {
            if( !initLoadClub &&
                clubsData && clubsData.length > 0){
                LoadSelectionClub();
                setInitLoadClub(true);
            }
        }, [clubsData]);

        useEffect(()=> {
            if( !initLoadBall &&
                selectedBall){
                LoadSelectionBall();
                setInitLoadBall(true);
            }
        }, [selectedBall]);

        useEffect(()=> {
            if( !initLoadLoft &&
                lofts && lofts.length > 0){
                LoadSelectionLofts();
                setInitLoadLoft(true);
            }
        }, [lofts]);

        useEffect(()=> {
            if( !initLoadShaft &&
                shafts && shafts.length > 0 &&
                shaftData && shaftData.length > 0){
                LoadSelectionShaft();
                setInitLoadShaft(true);
            }
        }, [shafts, shaftData]);

    function invalidatedField(field, isValid){
        if(!isValid){
            field.current.classList.add('new-setup-error-input');
        }else{
            field.current.classList.remove('new-setup-error-input');
        }
    }

    const tempFamilies = [
        {
            "Id": "PROTOTYPE",
            "Name": "Prototype",
            "FamilyId": "PROTOTYPE",
            "Category": "Woods",
            "CategoryId": "99",
            "isPrototype": true,
            "Lofts": null,
            "ImgURL": null
        },
        {
            "Id": "CUSTOM",
            "Name": "Custom",
            "FamilyId": "CUSTOM",
            "Category": "Woods",
            "CategoryId": "99",
            "isPrototype": true,
            "Lofts": null,
            "ImgURL": null
        },
        {
            "Id": "NONE",
            "Name": "NONE",
            "FamilyId": "Custom",
            "Category": "Woods",
            "CategoryId": "99",
            "isPrototype": true,
            "Lofts": null,
            "ImgURL": null
        }
    ];

    const tempShafts = [
        
    ];

    const connectResponse = (data) => {
        const response = JSON.parse(data.detail);
        const success = response["IsSuccess"];

        if(success === "false"){
            setModalState(false);
        }else{
            prefillData(response);
        }
    };

    const initCategoryData = async () => {
        let catData = await getCategoryData();
        return catData.map(cat => ({ value: cat.id, label: cat.name }));
    };
    const getCategoryData = async () => {
        let catData = await getCategories();
        catData = catData.filter(c => c.isClub && !c.deleted);
        setCategoriesData(catData);
        return catData;
    };

    const initClubData = async (categoryId) => {
        let clubData = [];

        if(GetCurrentSession().TaskId !== null && GetCurrentSession().TaskId != undefined && GetCurrentSession().TaskId !== ''){
            clubData.push(tempFamilies.find(c => c.Id === "PROTOTYPE"));
        }

        // clubData.push(tempFamilies.find(c => c.Id === "PROTOTYPE"));
        clubData.push(tempFamilies.find(c => c.Id === "CUSTOM"));

        if(selectedManufacturer.value !== "Callaway Golf"){
            return clubData;
        }

        let prodClubData = await getFamiliesByCategoryId(categoryId);

        let cats = categoriesData;

        if(!cats || cats.length == 0){
            cats = await getCategoryData();
        }

        for(let i = 0; i < prodClubData.length; i++){
            let club = prodClubData[i];

            if(club.Name.endsWith(" (PK)")){//Filter
                continue;
            }
            //let loftData = await getLofts(club.Id);
            //const prodLofts = loftData ? loftData.map(l => l.LoftIdentifierName) : ["No Loft Data Available"];
            const newClubData = {
                id:club.Id,
                Name:club.Name,
                FamilyId:club.Id,
                CategoryId:club.CategoryId,
                Category: cats.find(cat => cat.id === categoryId).name,
                isPrototype:false,
                //Lofts:prodLofts,
                ImgURL:club.ImageURL
            };
            clubData.push(newClubData);
        }

        return clubData;
    };

    const initBallData = async () => {
        const categoryId = "5";
        let ballData = [];
        let prodBallData = await getFamiliesByCategoryId(categoryId);

        ballData.push({
            id:"NONE",
            Name:"None",
            isPrototype:false,
            FamilyId:"NONE"
        });

        ballData.push({
            id:"PROTOTYPE",
            Name:"Prototype",
            isPrototype:true,
            FamilyId:"PROTOTYPE"
        });

        ballData.push({
            id:"CUSTOM",
            Name:"Custom",
            isPrototype:true,
            FamilyId:"CUSTOM"
        });

        ballData.push({
            id:"BALLSERIES",
            Name:"Ball Series Testing",
            isPrototype:false,
            
            FamilyId:"BALLSERIES"
        });

        for(let i = 0; i < prodBallData.length; i++){
            let ball = prodBallData[i];
            const newBallData = {
                id:ball.Id,
                Name:ball.Name,
                FamilyId:ball.Id,
                CategoryId:ball.CategoryId,
                isPrototype:false,
                // Lofts:prodLofts,
                ImgURL:ball.ImageURL
            };
            ballData.push(newBallData);
        }

        return ballData;
    }

    const initLoftData = async (club) => {

        const useableClub = club;//selectedClub ? selectedClub : club;

        if(selectedManufacturer.value === "Callaway Golf" && !ClubIsCustomOrPrototype(useableClub)){
            let lofts = await getLofts(useableClub.FamilyId);
            return lofts;
        }else{
            let lofts = DefaultClubLofts[selectedCategory.label].map(option => {
                return {
                    LoftIdentifierName: option
                };
            });
            return lofts;
        }
    }

    const initLofts = async (club) => {
        setSelectedLoft('');
        setPreSelectedLoft('');
        let _lofts = await initLoftData(club);
        if(!_lofts){
            _lofts = [{LoftIdentifierName:'No lofts available'}];
        }
        setLofts(_lofts.map(loft => ({value: loft.LoftIdentifierName, label: loft.LoftIdentifierName})));
    }

    const prefillData = async (jsondata) => {
        setPreloadedData(true);
        let data = jsondata;
        if(('UsingTee' in data)){
            setWithTeeCheckbox(!!data['UsingTee']);
        }else if(('WithTee' in data)){
            setWithTeeCheckbox(!!data['WithTee']);
        }else{
            setWithTeeCheckbox(false);
        }
       
        if(('CocoonId' in data)){
            setCocoonId(data["CocoonId"]);
            setValidPrototypeId(true);
            SetPrototypeId(data["CocoonId"]);
        }

        let cats = categoriesData;

        if(!cats || cats.length == 0){
            cats = await getCategoryData();
        }

        // let families = await getFamilies();
        // let familyData = families.find(f=>f.Id === data["FamilyId"]);
        let familyData = await getFamilyFromFamilyId(data["FamilyId"]);


        if(familyData === null || familyData === undefined){
            const initCatData = await initCategoryData();
            setCategories(initCatData);
            setCatLoading(false);
            setPreloadedData(null);
            return;
        }

        let categoryData = cats.find(cat => cat.id === familyData.CategoryId);
        let loftData = await getLofts(familyData.Id);
        const prodLofts = loftData.map(l => l.LoftIdentifierName);
        const clubData = {
            id:familyData.Id,
            Name:familyData.Name,
            FamilyId:familyData.Id,
            CategoryId:familyData.CategoryId,
            Category: categoryData.name,
            isPrototype:false,
            Lofts:prodLofts,
            ImgURL:familyData.ImageURL
        };
        // await handleCategoryChange({value:categoryData.id, label:categoryData.name});
        document.getElementById('clubIdInput').value = data["CocoonId"];
        setClubId(data["CocoonId"]);
        setClubLoading(false);
        setSelectedManufacturer({value:"Callaway Golf", label:"Callaway Golf"});
        setPreSelectedCategory({value:categoryData.id, label:categoryData.name});
        setSelectedCategory({value:categoryData.id, label:categoryData.name});
        doClubChange({value:data["FamilyId"]});
        setPreSelectedClub({value:data["FamilyId"], label:familyData.Name});
        setSelectedClub(clubData);
        setLofts(loftData.map(loft => ({value: loft.LoftIdentifierName, label: loft.LoftIdentifierName})));
        handleLoftChange({value: data["Loft"], label: data["Loft"]} );

        setShaftLoading(true);
        let shafts = await getShaftsByFamily(familyData.Id);
        AddShaftsToData(shafts);
        setShafts(shafts.map(shaft => ({value: shaft.Id, label: shaft.Description})));
        setShaftLoading(false);
    };

    async function createNewSetup(){
        const newId = generateGUID();
        const clubManufacturer = selectedManufacturer.value;
        const category = selectedCategory;
        const club = selectedClub;
        const clubid = clubId;
        const loft = selectedLoft;
        const prototype = validPrototypeId ? prototypeId : null;
        const custom = customName;
        const shaft = shaftData.find(s => s.Id === selectedShaft);
        const ball = selectedBall;
        const ballPrototype = ballPrototypeId;
        const ballCustom = ballCustomName;
        const description = clubDescription;

        const customClubId = selectedClub.FamilyId === "PROTOTYPE" ? prototype : clubid;

        const clubName = club.FamilyId === "CUSTOM" ? custom : club.Name;

        const customBallName = selectedBall !== null && selectedBall.FamilyId === "PROTOTYPE" ? ballPrototype : 
                                (selectedBall !== null && selectedBall.FamilyId === "CUSTOM" ? ballCustom : null);

        let newSetup= {
            Id: newId,
            LetterId: "",
            ClubManufacturer:clubManufacturer,
            ClubName: clubName,
            ClubId: customClubId,
            ClubDescription:description,
            ClubCategory : category.name,
            PCFamilyId: club.FamilyId,
            PCCategoryId: category.value,
            ClubLoft: loft.value,
            ShaftModel: shaft ? shaft.Description : "",
            ShaftPCCustomOptionId: shaft ? shaft.Id : "",
            BallName:ball ? ball.Name : "",
            BallFamilyId:ball ? ball.FamilyId : "",
            BallPrototypeId:customBallName,
            BaseComponentSN: customClubId,
            HeadSN: customClubId,
            ShaftSN: null,
            CocoonDeviceId:cocoonId,
            UsingTee: withTeeCheckbox,
            WedgeShotType: wedgeShotType,
            Adjustments:[],
            Shots:null,
            IsSelected:false,
            IsChecked:false,
            TaskmanImported:false
        };

        SaveSelection();
        setNewSetupAsOnlyChecked();
        await addNewSetup(newSetup);
        //  await selectNewSetup(newSetup); //ND - causing 412 error, moved the select code to the handleNewSetup
        setModalState(false);//close modal
    };

    function generateGUID() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16 | 0,
                v = c === 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    };

    async function createNewSetupSeries(){
        const seriesNum = ballSeriesCount;
        let newSetups = [];

        for( let i = -1; i < seriesNum; i++){
            const setupName = buildSeriesSetupId(i);
            const club = selectedClub;
            const clubManufacturer = selectedManufacturer.value;
            const category = selectedCategory;
            const loft = selectedLoft;
            const prototype = validPrototypeId ? prototypeId : null;
            const custom = customName;
            const clubid = clubId;
            const shaft = shaftData.find(s => s.Id === selectedShaft);
            const ball = selectedBall;
            const ballPrototype = ballPrototypeId;
            const description = clubDescription;

            const ballCustom = ballCustomName;

            const customClubId = selectedClub.FamilyId === "PROTOTYPE" ? prototype : clubid;

            const clubName = club.FamilyId === "CUSTOM" ? custom : club.Name;

            const customBallName =  selectedBall.FamilyId === "PROTOTYPE" ? ballPrototype : 
                                    (selectedBall.FamilyId === "CUSTOM" ? ballCustom : null);

            let newSetup= {
                Id: setupName,
                LetterId: "",
                ClubManufacturer:clubManufacturer,
                ClubName: clubName,
                ClubId: customClubId,
                ClubDescription:description,
                ClubCategory : category.name,
                PCFamilyId: club.FamilyId,
                PCCategoryId: category.value,
                ClubLoft: loft ? loft.value : "",
                ShaftModel: shaft ? shaft.Description : "",
                ShaftPCCustomOptionId: shaft ? shaft.Id : "",
                BallName:ball ? ball.Name : "",
                BallFamilyId:ball ? ball.FamilyId : "",
                BallPrototypeId:customBallName,
                BaseComponentSN: customClubId,
                HeadSN: customClubId,
                ShaftSN: null,
                CocoonDeviceId:cocoonId,
                UsingTee: withTeeCheckbox,
                WedgeShotType: wedgeShotType,
                Adjustments:[],
                Shots:null,
                IsSelected:i === -1 ? true : false,
                IsChecked:false,
                TaskmanImported:false
            };

            newSetups.push(newSetup);
        }

        SaveSelection();
        setNewSetupAsOnlyChecked();
        await addMultipleNewSetups(newSetups, ballSeries.map(item => item.name));
        // if(newSetups.length > 0){
        //     await selectNewSetup(newSetups[0]);
        // }
        setModalState(false);//close modal
    };
        function setNewSetupAsOnlyChecked(){
        const currentSession = GetCurrentSession();

        if(!currentSession || !currentSession.SessionSetups){
            return;
        }

        currentSession.SessionSetups = currentSession.SessionSetups.map(setup => ({...setup, IsChecked:false}));
    };

    async function selectNewSetup(newSetup){
        const currentSession = GetCurrentSession();

        if(!currentSession || !currentSession.SessionSetups){
            return;
        }

        const sessionSetup = currentSession.SessionSetups.find(s => s.Id === newSetup.Id) || newSetup;
        await SelectSessionSetup(currentSession, sessionSetup);

        const updateDb = !viewOnly;
        await CheckAllSessionSetup(false, updateDb);
        await CheckSessionSetup(currentSession, sessionSetup, true, updateDb);

        session_update(currentSession.id, sessionSetup.Id, viewOnly);
    };
    function buildSeriesSetupId(index){
        if (index === -1)
            return 'Setup Series';

        return 'Series ' + (index + 1).toString();
    }

    const handleManufacturerChange = async (manufacturer) => {
        setSelectedManufacturer(manufacturer);

        if(selectedCategory != null){
            setSelectedCategory({value:selectedCategory.value, label:selectedCategory.label} );//redraw clubs

            if(selectedClub != null && !ClubIsCustomOrPrototype(selectedClub)){
                setSelectedClub(null);
                setPreSelectedClub(null);
            }
        }
    }

    const handleCategoryChange = async (category) => {
        setSelectedCategory(category);
    };

    const doClubChange = (club) => {
        let selClub = clubsData.find(c => c.FamilyId === club.value);
        setSelectedClub(selClub);
        return selClub;
    };

    const doBallChange = (ball) => {
        let selBall = ballsData.find(b => b.FamilyId === ball.value);
        setSelectedBall(selBall);
        setPreSelectedBall({value:ball.value, label:ball.label});

        if(selBall.FamilyId == "BALLSERIES"){//special ball family for ball series
            setUseBallSeries(true);
        }else{
            setUseBallSeries(false);
        }

        return selBall;
    };

    const updateInputsById = (id, value) => {
        const inputElements = document.querySelectorAll(`#${id}`);
        inputElements.forEach(element => {
            element.value = value;
        });
    };

    const ensureWoodsCategory = async () => {
        let woodsCategory = categories.find(cat => cat.label === "Woods");

        if(!woodsCategory){
            const initCatData = await initCategoryData();
            setCategories(initCatData);
            woodsCategory = initCatData.find(cat => cat.label === "Woods");
        }

        if(woodsCategory){
            setSelectedCategory(woodsCategory);
            setPreSelectedCategory(woodsCategory);
        }
    };

    const handleClubChange = async (club) => {
        setPreSelectedClub(club);
        let selClub = doClubChange(club);
        await initLofts(selClub);
    }

    function AddShaftsToData(newShafts){
        let newShaftList = shaftData;
        newShafts.forEach(shaft => {
            const exists = newShaftList.some(s => s.Id === shaft.Id);

            if(!exists){
                newShaftList.push(shaft);
            }
        });
        setShaftData(newShaftList);
    }

    const handleLoftChange = async (loft) => {
        setPreSelectedLoft(loft);
        setSelectedLoft(loft);
    }

    const handlePrototypeChange = (e) => {
        SetPrototypeId(e.target.value);
        const regex = /^HD-\d{7}$/;
            if (regex.test(e.target.value)) {
            // setPrototypeColor('green');
            setValidPrototypeId(true);
            } else {
            // setPrototypeColor('red');
            setValidPrototypeId(false);
        }
    };

    const handleDescriptionChange = (e) => {
        setClubDescription(e.target.value);
    };

    const handlePrototypeBallChange = (e) => {
        SetBallPrototypeId(e.target.value);
    };

    const handleCustomBallChange = (e) => {
        SetBallCustomName(e.target.value);
    };

    const setPrototypeColor = (color) => {
        const messageElement = document.getElementById('prototypeInput');
        messageElement.style.backgroundColor = color;
      };

    const handleCustomChange = (e) => {
        setCustomName(e.target.value);
    };

    const handleClubIdChange = (e) => {
        setClubId(e.target.value);
    };

    const handleShaftChange = (e) => {
        setPreSelectedShaft(e);
        setSelectedShaft(e.value);
        const newShaft = shaftData.find(shaft => shaft.Id === e.value);
        setSelectedShaftData(newShaft ? newShaft : null);
    };

    const handleBallChange = async (ball) => {
        let selBall = doBallChange(ball);

        if(selBall?.FamilyId === "BALLSERIES"){
            await ensureWoodsCategory();
            setSelectedLoft("");
            setPreSelectedLoft("");
            setCustomName("");
            setClubId("");
            updateInputsById("customInput", "");
            updateInputsById("clubIdInput", "");
        }
    };

    useEffect(() => {
        if(selectedBall?.FamilyId !== "BALLSERIES"){
            return;
        }

        setSelectedLoft("");
        setPreSelectedLoft("");
        setCustomName("");
        setClubId("");
        updateInputsById("customInput", "");
        updateInputsById("clubIdInput", "");

        const noneClub = clubsData.find(club => club.FamilyId === "NONE") ?? {
            id:"NONE",
            Id:"NONE",
            Name:"None",
            FamilyId:"NONE",
            CategoryId:selectedCategory?.value,
            Category:selectedCategory?.label,
            isPrototype:false
        };

        setSelectedClub(noneClub);
        setPreSelectedClub({value:noneClub.FamilyId, label:noneClub.Name});
    }, [selectedBall, clubsData, selectedCategory]);

    const handleBallSeriesCheck = (e) => {
        setUseBallSeries(!useBallSeries);
    };

    const handleBallSeriesAddEnter = (e) => {
        if(e.key === "Enter"){
            handleBallSeriesAdd();
        }
    };

    const handleBallSeriesAdd = (e) => {
        const input = document.getElementById("newSeriesInput");
        const newSeries = input?.value?.trim() || "";
        if (newSeries && !ballSeries.some(item => item.name === newSeries)) {
            setBallSeries(prevSeries => [...prevSeries, createBallSeriesItem(newSeries)]);
            if (input) {
                input.value = "";
            }
        }
    };

    const handleBallSeriesDelete = (id) => {
        setBallSeries(prevSeries => prevSeries.filter(item => item.id !== id));
    };

    const handleBallSeriesRename = (id, value) => {
        setBallSeries(prevSeries =>
            prevSeries.map(item => item.id === id ? { ...item, name: value } : item)
        );
    };

    const handleBallSeriesDragEnd = ({ active, over }) => {
        if (!over || active.id === over.id) {
            return;
        }

        setBallSeries(prevSeries => {
            const oldIndex = prevSeries.findIndex(item => item.id === active.id);
            const newIndex = prevSeries.findIndex(item => item.id === over.id);

            if (oldIndex < 0 || newIndex < 0) {
                return prevSeries;
            }

            return arrayMove(prevSeries, oldIndex, newIndex);
        });
    };

    const DeleteSeriesIcon = () => (
        <svg width="30" height="30" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M24.4437 24.5566L38.5858 38.6988L41.4142 41.5272L55.5564 55.6693" className='icon-stroke' strokeWidth="6" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M55.5563 24.5566L41.4142 38.6988L38.5858 41.5272L24.4436 55.6693" className='icon-stroke' strokeWidth="6" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    );

    const ChevronDownIcon = () => (
        <svg width="20" height="20" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M16.0371 52.3672L36.8551 31.5492C38.6125 29.7918 41.4617 29.7918 43.2191 31.5492L64.0371 52.3672" className='icon-stroke' stroke-width="6" stroke-linecap="round" stroke-linejoin="round" transform='rotate(180,40,40)' />
        </svg>
    );

    const ChevronUpIcon = () => (
        <svg width="20" height="20" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M16.0371 52.3672L36.8551 31.5492C38.6125 29.7918 41.4617 29.7918 43.2191 31.5492L64.0371 52.3672" className='icon-stroke' stroke-width="6" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
    );

    function ClubIsCustomOrPrototype(club){
        return (club.FamilyId === "PROTOTYPE" || club.FamilyId === "CUSTOM");
    }

    const handleModalClose = () => {
        setModalState(false);
            disconnect_sensor();
    }

    function SaveSelection(){
        let saveData = {};

        saveData.manufacturer = selectedManufacturer.value;

        saveData.category = selectedCategory.value;

        saveData.club = selectedClub.FamilyId;
        saveData.loft = selectedLoft.value;
        saveData.clubDescription = clubDescription;
        saveData.clubCustomName = customName;
        saveData.clubPrototypeId = prototypeId;
        saveData.clubId = clubId;

        saveData.shaft = selectedShaft;

        saveData.usingTee = withTeeCheckbox;
        saveData.wedgeShotType = wedgeShotType;

        saveData.ball = selectedBall.FamilyId;
        saveData.ballCustomName = ballCustomName;
        saveData.ballPrototypeId = ballPrototypeId;

        sessionStorage.setItem("NewSetupSavedData",JSON.stringify(saveData));
    }

    function LoadSelectionInit(){
        const loadJSON = sessionStorage.getItem("NewSetupSavedData") ? sessionStorage.getItem("NewSetupSavedData") : "{}";
        const loadData = JSON.parse(loadJSON);

        if(loadData.hasOwnProperty('manufacturer')){
            setSelectedManufacturer({value: loadData.manufacturer, label: loadData.manufacturer});
        }

        if(loadData.hasOwnProperty('category')){
            setSelectedCategory(categories.find(cat => cat.value === loadData.category));
        }

        if(loadData.hasOwnProperty('ball')){
            const loadBall = ballsData.find(ba => ba.FamilyId === loadData.ball);
            doBallChange({value: loadBall.FamilyId, label: loadBall.Name });
            // setSelectedBall({value: loadBall.FamilyId, label: loadBall.Name });
            // setPreSelectedBall({value: loadBall.FamilyId, label: loadBall.Name });
        }

        if(loadData.hasOwnProperty('usingTee')){
            setWithTeeCheckbox(!!loadData.usingTee);
        }else{
            setWithTeeCheckbox(false);
        }
        if(loadData.hasOwnProperty('wedgeShotType')){
            setWedgeShotType(!!loadData.wedgeShotType);
        }else{
            setWedgeShotType(false);
        }
    }

    async function LoadSelectionClub(){
        const loadJSON = sessionStorage.getItem("NewSetupSavedData") ? sessionStorage.getItem("NewSetupSavedData") : "{}";
        const loadData = JSON.parse(loadJSON);

        if(loadData.hasOwnProperty('club')){
            const loadClub = clubsData.find(c => c.FamilyId === loadData.club);
            setSelectedClub(loadClub);
            setPreSelectedClub({value:loadClub.FamilyId, label:loadClub.Name});
        }
    }

    async function LoadSelectionClubOptions(){
        const loadJSON = sessionStorage.getItem("NewSetupSavedData") ? sessionStorage.getItem("NewSetupSavedData") : "{}";
        const loadData = JSON.parse(loadJSON);

        if(loadData.hasOwnProperty('club')){
            if(loadData.club === 'PROTOTYPE'){
                if(loadData.hasOwnProperty('clubPrototypeId') && loadData.clubPrototypeId !== ''){
                    while(true){
                        if(prototypeInput.current !== null){
        
                            const inputElements = document.querySelectorAll("#prototypeInput"); // Select all elements with the same id
                            if (inputElements.length > 0) {
                                inputElements.forEach((inputElement) => {
                                    inputElement.value = loadData.clubPrototypeId; // Update all inputs with the same value
                                });
                                console.log(`Updated ${inputElements.length} inputs with the same value.`);
                            }
        
                            SetPrototypeId(loadData.clubPrototypeId);
                            const regex = /^HD-\d{7}$/;
                            if (regex.test(loadData.clubPrototypeId)) {
                                // setPrototypeColor('green');
                                setValidPrototypeId(true);
                            } else {
                                // setPrototypeColor('red');
                                setValidPrototypeId(false);
                            }
                            break;
                        }
        
                        await new Promise(resolve => setTimeout(resolve, 100));
                    }
                }

                if(loadData.hasOwnProperty('clubDescription') && loadData.clubDescription !== ''){
                    while(true){
                        if(clubDescriptionInput.current !== null){
        
                            const inputElements = document.querySelectorAll("#clubDescriptionInput"); // Select all elements with the same id
                            if (inputElements.length > 0) {
                                inputElements.forEach((inputElement) => {
                                    inputElement.value = loadData.clubDescription; // Update all inputs with the same value
                                });
                                console.log(`Updated ${inputElements.length} inputs with the same value.`);
                            }
        
                            setClubDescription(loadData.clubDescription);
                            break;
                        }
        
                        await new Promise(resolve => setTimeout(resolve, 100));
                    }
                }
            }else if(loadData.club === 'CUSTOM'){
                if(loadData.hasOwnProperty('clubCustomName') && loadData.clubCustomName !== ''){
                    while(true){
                        if(customInput.current !== null){
        
                            const inputElements = document.querySelectorAll("#customInput"); // Select all elements with the same id
                            if (inputElements.length > 0) {
                                inputElements.forEach((inputElement) => {
                                    inputElement.value = loadData.clubCustomName; // Update all inputs with the same value
                                });
                                console.log(`Updated ${inputElements.length} inputs with the same value.`);
                            }
        
                            setCustomName(loadData.clubPrototypeId);
                            break;
                        }
                    }
                }
            }else{
                if(loadData.hasOwnProperty('clubId') && loadData.clubId !== ''){
                    while(true){
                        if(clubIdInput.current !== null){
        
                            const inputElements = document.querySelectorAll("#clubIdInput"); // Select all elements with the same id
                            if (inputElements.length > 0) {
                                inputElements.forEach((inputElement) => {
                                    inputElement.value = loadData.clubId; // Update all inputs with the same value
                                });
                                console.log(`Updated ${inputElements.length} inputs with the same value.`);
                            }
        
                            setClubId(loadData.clubId);
                            break;
                        }
        
                        await new Promise(resolve => setTimeout(resolve, 100));
                    }
                }
            }
        }
    }

    function LoadSelectionLofts(){
        const loadJSON = sessionStorage.getItem("NewSetupSavedData") ? sessionStorage.getItem("NewSetupSavedData") : "{}";
        const loadData = JSON.parse(loadJSON);

        if(loadData.hasOwnProperty('loft')){
            setSelectedLoft({value:loadData.loft, label:loadData.loft});
            setPreSelectedLoft({value:loadData.loft, label:loadData.loft});
        }
    }

    function LoadSelectionShaft(){
        const loadJSON = sessionStorage.getItem("NewSetupSavedData") ? sessionStorage.getItem("NewSetupSavedData") : "{}";
        const loadData = JSON.parse(loadJSON);

        if(loadData.hasOwnProperty('shaft') && loadData.shaft !== ''){
            const loadShaft = shaftData.find(sh => sh.Id === loadData.shaft);
            
            setSelectedShaft(loadShaft.Id);
            setPreSelectedShaft({value: loadShaft.Id, label: loadShaft.Description});
            setSelectedShaftData(loadShaft);
        }
    }

    async function LoadSelectionBall(){
        const loadJSON = sessionStorage.getItem("NewSetupSavedData") ? sessionStorage.getItem("NewSetupSavedData") : "{}";
        const loadData = JSON.parse(loadJSON);

        if(loadData.hasOwnProperty('ball')){
            const loadBall = ballsData.find(ba => ba.FamilyId === loadData.ball);
            
            if(loadBall.FamilyId === 'PROTOTYPE'){
                if(loadData.hasOwnProperty('ballPrototypeId') && loadData.ballPrototypeId !== ''){
                    while(true){
                        if(ballPrototypeInput.current !== null){
        
                            const inputElements = document.querySelectorAll("#prototypeInputBall"); // Select all elements with the same id
                            if (inputElements.length > 0) {
                                inputElements.forEach((inputElement) => {
                                    inputElement.value = loadData.ballPrototypeId; // Update all inputs with the same value
                                });
                                console.log(`Updated ${inputElements.length} inputs with the same value.`);
                            }
        
                            SetBallPrototypeId(loadData.ballPrototypeId);
                            
                            break;
                        }
        
                        await new Promise(resolve => setTimeout(resolve, 100));
                    }
                }
            }else if(loadBall.FamilyId === 'CUSTOM'){
                if(loadData.hasOwnProperty('ballCustomName') && loadData.ballCustomName !== ''){
                    while(true){
                        if(ballCustomInput.current !== null){
        
                            const inputElements = document.querySelectorAll("#customInputBall"); // Select all elements with the same id
                            if (inputElements.length > 0) {
                                inputElements.forEach((inputElement) => {
                                    inputElement.value = loadData.ballCustomName; // Update all inputs with the same value
                                });
                                console.log(`Updated ${inputElements.length} inputs with the same value.`);
                            }
        
                            SetBallCustomName(loadData.ballCustomName);
                            
                            break;
                        }
        
                        await new Promise(resolve => setTimeout(resolve, 100));
                    }
                }
            }
        }
    }

const DesktopRender = () => {

    return(
<div className='desktop-new-setup-container'>
        <button className='modal-close-button' onClick={() => handleModalClose()}><Cross2Icon width='30px' height='30px'/></button>
        <div className='desktop-new-setup-header'>
            <span style={{fontSize:'24px', fontWeight:'bold'}}>New Setup</span>
        </div>
        <div className={`desktop-new-setup-middle ${orientation}`}>
            <div style={{gridColumn: '1 / span 2', gridRow: 1}}>
                <span style={{fontSize:'20px', fontWeight:'bold', paddingLeft:'20px'}}>Club</span>
            </div>
            <div style={{gridColumn: 1, gridRow: 2}} className='desktop-new-setup-top-row-container'>
                <div className='desktop-new-setup-input-header'>
                    <h4>Manufacturer</h4>
                    <Select
                        className='desktop-new-setup-select'
                        isDisabled={preLoadedData}
                        options={manufacturers}
                        name='ManufacturerSelect'
                        onChange={handleManufacturerChange}
                        value={selectedManufacturer}
                        menuPlacement="auto"
                        />
                </div>
            </div>
            <div style={{gridColumn: 2, gridRow: 2}} className='desktop-new-setup-top-row-container'> 
                <div className='desktop-new-setup-input-header' >
                    <h4 style={{ marginRight: 0 }}>Category</h4>
                    <div ref={categoryInput} style={{ flex:'1', marginLeft:'0px'}}>
                        <Select
                            className='desktop-new-setup-select-nomargin'
                            isLoading={catLoading}
                            isDisabled={catLoading || preLoadedData}
                            options={categories}
                            name='CategorySelect'
                            onChange={handleCategoryChange}
                            value={preSelectedCategory}
                            menuPlacement="auto"
                            />
                    </div>
                </div>
                    
                <div style={{ marginLeft: '115px' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '20px', marginTop: '15px' }}>
                    
                    {/* Using Tee */}
                    <div style={{ display: 'flex', alignItems: 'center'}}>
                    <input
                        id="usingTeeCheckbox"
                        type="checkbox"
                        style={{ width: '25px', height: '25px' }}
                        checked={withTeeCheckbox}
                        onChange={(event) => setWithTeeCheckbox(event.target.checked)}
                        disabled={selectedCategory?.label === "Putters"}
                    />
                    <label htmlFor="usingTeeCheckbox" style={{ marginLeft: '10px' }}>
                        Using Tee
                    </label>
                    </div>

                    {/* Wedge Type (same row) */}
                    {selectedCategory?.label === "Wedges" && (
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                        
                        <select
                        id="wedgeShotType"
                        value={wedgeShotType}
                        style={{ width: '120', height: '27px' }}
                        onChange={(event) => setWedgeShotType(event.target.value)}
                        >
                        <option value="">Select</option>
                        <option value="full">Full</option>
                        <option value="chip">Chip</option>
                        <option value="pitch">Pitch</option>
                        <option value="flop">Flop</option>
                        <option value="bunker">Bunker</option>
                        </select>
                    </div>
                    )}

                </div>
                </div>

            </div>
            <div style={{gridColumn: 1, gridRow: 3, marginTop: '30px' }} className='desktop-new-setup-bottom-row-container'>
                <div className='desktop-new-setup-input-header'>
                    <h4>Clubhead</h4>
                    <div ref={clubInput} style={{ flex:'1', marginLeft:'10px'}}>
                        <Select
                            className='desktop-new-setup-select-nomargin'
                            isLoading={clubLoading}
                            isDisabled={(!clubs || clubLoading) || preLoadedData}
                            options={clubs}
                            name='ClubSelect'
                            onChange={handleClubChange}
                            value={preSelectedClub}
                            menuPlacement="auto"
                            />
                    </div>
                </div>
                {selectedClub && selectedClub.ImgURL && (
                        <img src={selectedClub && selectedClub.ImgURL ? selectedClub.ImgURL : ""} className='desktop-new-setup-image' style={orientation === "portrait" ? {maxHeight:'250px'} : {}}/>
                )}
                <></>
                {((selectedClub && (selectedClub.Id !== "PROTOTYPE" || selectedClub.Id !== "CUSTOM")) || preLoadedData) && selectedBall?.FamilyId !== "BALLSERIES" && (
                    <div className='desktop-new-setup-input-header'>
                        <h4>Loft</h4>
                        <div ref={loftInput} style={{ flex:'1', marginLeft:'10px'}}>
                            <Select
                                className='desktop-new-setup-select-nomargin'
                                options={lofts}
                                isDisabled={preLoadedData}
                                name='LoftSelect'
                                onChange={handleLoftChange}
                                value={preSelectedLoft}
                                menuPlacement="auto"
                                />
                            </div>
                    </div>
                )}
                <></>
                {((selectedClub && (selectedClub.Id !== "PROTOTYPE" && selectedClub.Id !== "CUSTOM")) || preLoadedData) && selectedBall?.FamilyId !== "BALLSERIES" && (
                    <div className='desktop-new-setup-input-header'>
                        <h4>Club Id</h4>
                        <div ref={clubIdInput} style={{ flex:'1', marginLeft:'10px'}}>
                            <input
                                id="clubIdInput"
                                className="input"
                                type="text"
                                onChange={handleClubIdChange}
                                />
                        </div>
                    </div>
                )}
                <></>
                {(selectedClub && selectedClub.Id === "PROTOTYPE") && (
                    <>
                    <div className='desktop-new-setup-input-header'>
                        <h4>Prototype Id</h4>
                        <div ref={prototypeInput} style={{ flex:'1', marginLeft:'10px'}}>
                            <input
                                id="prototypeInput"
                                className="input"
                                type="text"
                                onChange={handlePrototypeChange}
                                />
                            </div>
                    </div>
                    <div className='desktop-new-setup-input-header'>
                        <h4>Description</h4>
                        <div ref={clubDescriptionInput} style={{ flex:'1', marginLeft:'10px'}}>
                            <input
                                id="clubDescriptionInput"
                                className="input"
                                type="text"
                                onChange={handleDescriptionChange}
                                />
                            </div>
                    </div>
                    </>
                )}
                <></>
                {(selectedClub && selectedClub.Id === "CUSTOM") && selectedBall?.FamilyId !== "BALLSERIES" && (
                    <>
                    <div className='desktop-new-setup-input-header'>
                        <h4>Custom Name</h4>
                        <div ref={customInput} style={{ flex:'1', marginLeft:'10px'}}>
                            <input
                                id="customInput"
                                className="input"
                                type="text"
                                onChange={handleCustomChange}
                                />
                        </div>
                    </div>
                    <div className='desktop-new-setup-input-header'>
                        <h4>Club Id</h4>
                        <div ref={clubIdInput} style={{ flex:'1', marginLeft:'10px'}}>
                            <input
                                id="clubIdInput"
                                className="input"
                                type="text"
                                onChange={handleClubIdChange}
                                />
                        </div>
                    </div>
                    </>
                )}
            </div>
            
            <div style={{gridColumn: 2, gridRow: 3, marginTop: '30px' }} className='desktop-new-setup-top-row-container'>
            
            <div className='desktop-new-setup-input-header'>
                <h4>Shaft</h4>
                <Select
                    className='desktop-new-setup-select'
                    isLoading={shaftLoading}
                    isDisabled={!shafts}
                    options={shafts}
                    name='ClubSelect'
                    menuPlacement="auto"
                    value={preSelectedShaft}
                    onChange={handleShaftChange}/>
                </div>
                {selectedShaftData && selectedShaftData.ImageURL && (
                        <img src={selectedShaftData && selectedShaftData.ImageURL ? selectedShaftData.ImageURL : ""} className='desktop-new-setup-image'/>
                )}
            </div>
            <div style={orientation === "landscape" ? {gridColumn: 3, gridRow: 1} : {gridColumn: 1, gridRow: '4 / span 2'}}>
                <span style={{fontSize:'20px', fontWeight:'bold', paddingLeft:'20px'}}>Ball</span>
            </div>
            <div style={orientation === "landscape" ? {gridColumn: 3, gridRow: '2 / span 2', overflow:'auto'} :
                                                        {gridColumn: '1 / span 2', gridRow: 5, overflow:'auto'}} className={`desktop-new-setup-ball-container ${orientation}`}>
                <div style={{gridColumn:'1', display:'flex', flexDirection:'column', justifyContent:'start'}}>
                <Select
                    className='select'
                    isLoading={ballLoading}
                    isDisabled={!balls}
                    options={balls}
                    name='BallSelect'
                    onChange={handleBallChange}
                    value={preSelectedBall}
                    styles={{zindex:"10"}}
                    menuPlacement="auto"
                    />
                    {selectedBall && selectedBall.ImgURL && (
                        <img src={selectedBall && selectedBall.ImgURL ? selectedBall.ImgURL : ""} className='desktop-new-setup-image'  style={orientation === "portrait" ? {maxHeight:'250px'} : {}}/>
                    )}
                    <></>
                    {selectedBall && selectedBall.isPrototype && selectedBall.id === "PROTOTYPE" ? (
                        <div>
                            <h4>Ball Prototype Id</h4>
                            <div ref={ballPrototypeInput}>
                                <input
                                    id="prototypeInputBall"
                                    className="input"
                                    type="text"
                                    onChange={handlePrototypeBallChange}
                                    />
                            </div>
                        </div>
                    ) :
                    <div></div>}
                    <></>
                    {selectedBall && selectedBall.isPrototype && selectedBall.id === "CUSTOM" ? (
                        <div>
                            <h4>Custom Ball</h4>
                            <div ref={ballCustomInput}>
                                <input
                                    id="customInputBall"
                                    className="input"
                                    type="text"
                                    onChange={handleCustomBallChange}
                                    />
                            </div>
                        </div>
                    ) :
                    <div></div>}
                    <></>
                {useBallSeries ? (
                    <>
                        <div className='ball-series-add-container' ref={ballSeriesContainer}>
                            <input
                                type='text'
                                id="newSeriesInput"
                                className="input"
                                onKeyDown={handleBallSeriesAddEnter}
                                />
                            <button
                                className='button'
                                style={{width:"100px"}}
                                onClick={handleBallSeriesAdd}>
                                Add Group
                            </button>
                        </div>
                        {orientation === "portrait" &&  (
                        <div className='ball-series-num-series-container' ref={ballSeriesNumberInput} style={{marginTop:'auto'}}>
                            <label htmlFor="numSeriesInput">Number of Series</label>
                            <div>
                                <input
                                    type="number"
                                    id="numSeriesInput"
                                    name="numSeriesInput"
                                    className='input'
                                    value={ballSeriesCount}
                                    onChange={(e) => setBallSeriesCount(parseInt(e.target.value, 10) || 0)}
                                    />
                            </div>
                        </div>
                        )}
                    </>
                ) : (<></>)}
                </div>
                <div style={{gridColumn:'2', display:'flex', flexDirection:'column', justifyContent:'start'}}>
                {useBallSeries ? (
                    <>
                    <div style={{width:"100%", height: orientation === "landscape" ? "400px" : "100%"}}>
                        <div className='ball-series-container'>
                            <DndContext sensors={sensors} collisionDetection={closestCenter} onDragEnd={handleBallSeriesDragEnd}>
                                <SortableContext items={ballSeries.map(item => item.id)} strategy={verticalListSortingStrategy}>
                                    {ballSeries.map((item,index) => (
                                        <SortableBallSeriesItem
                                            key={item.id}
                                            item={item}
                                            index={index}
                                            textAlign="left"
                                            onRename={handleBallSeriesRename}
                                            onDelete={handleBallSeriesDelete}
                                            DeleteSeriesIcon={DeleteSeriesIcon}
                                        />
                                    ))}
                                </SortableContext>
                            </DndContext>
                        </div>
                    </div>
                    {orientation === "landscape" && (
                        <div className='ball-series-num-series-container' ref={ballSeriesNumberInput}>
                            <label htmlFor="numSeriesInput">Number of Series</label>
                            <div>
                                <input
                                    type="number"
                                    id="numSeriesInput"
                                    name="numSeriesInput"
                                    className='input'
                                    value={ballSeriesCount}
                                    onChange={(e) => setBallSeriesCount(parseInt(e.target.value, 10) || 0)}
                                    />
                            </div>
                        </div>
                    )}
                    </>
                    ) : <div style={{height:'20px'}}></div>}
                    <></>
                </div>
            </div>
        </div>
        <div className='desktop-new-setup-button-container'>
            <button className="button" style={{height:'40px'}} disabled={!validSetup} onClick={!useBallSeries ? createNewSetup : createNewSetupSeries}>Add</button>
            {/* <button className="button" style={{height:'40px'}} onClick={() => handleModalClose()}>Close</button> */}
        </div>
</div>
    );

}

const MobileRender = () => {
    return(
<div className='new-setup-container'>
    <button className='modal-close-button' onClick={() => handleModalClose()}><Cross2Icon width='30px' height='30px'/></button>
    <h2>New Setup</h2>
    <div className='new-setup-inner-container'>
        {/* <Collapsible trigger={(
            <div className='new-setup-collapseable'>
                <div style={{width:"100px", paddingLeft:"10px"}}>
                    Club
                </div>
                <div style={{width:"100%", textAlign:"end", paddingRight:"10px"}}>
                    {selectedClub ? selectedClub.Name : ""}
                </div>
                <div style={{width:"40px"}}>
                    <ChevronDownIcon/>
                </div>
            </div>
        )}
        transitionTime={1}> */}
        <h2>Club</h2>
        <h4>Manufacturer</h4>
        <Select
            className='select'
            isDisabled={preLoadedData}
            options={manufacturers}
            name='ManufacturerSelect'
            onChange={handleManufacturerChange}
            value={selectedManufacturer}
            menuPlacement="auto"
            />
        <h4>Category</h4>
        <div ref={categoryInput}>
            <Select
                className='select'
                isLoading={catLoading}
                isDisabled={catLoading || preLoadedData}
                options={categories}
                name='CategorySelect'
                onChange={handleCategoryChange}
                value={preSelectedCategory}
                menuPlacement="auto"
                />
        </div>
        <div style={{display:'flex', alignItems:'center', marginTop:'10px'}}>
            <input
                id="usingTeeCheckboxMobile"
                type="checkbox"
                style={{width:'25px', height:'25px'}}
                checked={withTeeCheckbox}
                onChange={(event) => setWithTeeCheckbox(event.target.checked)}
                //disabled={isPutters}
                disabled = {selectedCategory?.label === "Putters"}
            />
            <label htmlFor="usingTeeCheckboxMobile" style={{marginLeft:'10px'}}>Using Tee</label>
       
        {selectedCategory?.label === "Wedges" && (
            <div style={{ display: 'flex', alignItems: 'center', marginLeft: '10px', marginTop: '10px' }}>
                    <select
                        id="wedgeShotTypeMobile"
                        value={wedgeShotType}
                        style={{ width: '120px', height: '30px' }}
                        onChange={(event) => setWedgeShotType(event.target.value)}
                        disabled={selectedCategory?.label !== "Wedges"}
                    >
                        <option value="">Select type</option>
                        <option value="chip">Chip</option>
                        <option value="pitch">Pitch</option>
                        <option value="flop">Flop</option>
                        <option value="bunker">Bunker</option>
                    </select>

                    <label htmlFor="wedgeShotTypeMobile" style={{ marginLeft: '10px' }}>
                        Type
                    </label>
            </div>
            
        )}
         </div>
        <h4>Club</h4>
        <div ref={clubInput}>
            <Select
                className='select'
                isLoading={clubLoading}
                isDisabled={(!clubs || clubLoading) || preLoadedData}
                options={clubs}
                name='ClubSelect'
                onChange={handleClubChange}
                value={preSelectedClub}
                menuPlacement="auto"
                />
        </div>
            <></>
            {((selectedClub && (selectedClub.Id !== "PROTOTYPE" || selectedClub.Id !== "CUSTOM")) || preLoadedData) && selectedBall?.FamilyId !== "BALLSERIES" && (
                <div>
                    <h5 style={{paddingLeft:'10px'}}>Loft</h5>
                    <div ref={loftInput}>
                        <Select
                            className='select'
                            options={lofts}
                            isDisabled={preLoadedData}
                            name='LoftSelect'
                            onChange={handleLoftChange}
                            value={preSelectedLoft}
                            menuPlacement="auto"
                            />
                        </div>
                </div>
            )}
            <></>
            {((selectedClub && (selectedClub.Id !== "PROTOTYPE" && selectedClub.Id !== "CUSTOM")) || preLoadedData) && selectedBall?.FamilyId !== "BALLSERIES" && (
                <div>
                    <h4>Club Id</h4>
                    <div ref={clubIdInput} >
                        <input
                            id="clubIdInput"
                            className="input"
                            type="text"
                            onChange={handleClubIdChange}
                            />
                    </div>
                </div>
            )}
            <></>
            {(selectedClub && selectedClub.Id === "PROTOTYPE") && (
                <div>
                    <h5 style={{paddingLeft:'10px'}}>Prototype Id</h5>
                    <div ref={prototypeInput}>
                        <input
                            id="prototypeInput"
                            className="input"
                            type="text"
                            onChange={handlePrototypeChange}
                            />
                        </div>
                    <h5 style={{paddingLeft:'10px'}}>Description</h5>
                    <div ref={clubDescriptionInput}>
                        <input
                            id="clubDescriptionInput"
                            className="input"
                            type="text"
                            onChange={handleDescriptionChange}
                            />
                        </div>
                </div>
            )}
            <></>
            {(selectedClub && selectedClub.Id === "CUSTOM") && selectedBall?.FamilyId !== "BALLSERIES" && (
                <>
                <div>
                    <h4>Custom Name</h4>
                    <div ref={customInput}>
                        <input
                            id="customInput"
                            className="input"
                            type="text"
                            onChange={handleCustomChange}
                            />
                    </div>
                </div>
                <div>
                    <h4>Club Id</h4>
                    <div ref={clubIdInput} >
                        <input
                            id="clubIdInput"
                            className="input"
                            type="text"
                            onChange={handleClubIdChange}
                            />
                    </div>
                </div>
                </>
                
            )}
        <h4>Shaft</h4>
        <Select
            className='select'
            isLoading={shaftLoading}
            isDisabled={!shafts}
            options={shafts}
            name='ClubSelect'
            menuPlacement="auto"
            value={preSelectedShaft}
            onChange={handleShaftChange}/>
        {/* </Collapsible> */}
        
        {/* <Collapsible trigger={(
            <div className='new-setup-collapseable'>
                <div style={{width:"100px", paddingLeft:"10px"}}>
                    Ball
                </div>
                <div style={{width:"100%", textAlign:"end", paddingRight:"10px"}}>
                    {selectedBall ? selectedBall.Name : ""}
                </div>
                <div style={{width:"40px"}}>
                    <ChevronDownIcon/>
                </div>
            </div>
        )}
        transitionTime={1}> */}
        <div style={{marginTop:"20px"}}>
        <h2>Ball</h2>
        <Select
            className='select'
            isLoading={ballLoading}
            isDisabled={!balls}
            options={balls}
            name='BallSelect'
            onChange={handleBallChange}
            value={preSelectedBall}
            styles={{zindex:"10"}}
            menuPlacement="auto"
            />
            <></>
            {selectedBall && selectedBall.isPrototype && selectedBall.id === "PROTOTYPE" ? (
                <div>
                    <h5>Ball Prototype Id</h5>
                    <div ref={ballPrototypeInput}>
                        <input
                            id="prototypeInputBall"
                            className="input"
                            type="text"
                            onChange={handlePrototypeBallChange}
                            />
                    </div>
                </div>
            ) :
            <div></div>}
            <></>
            {selectedBall && selectedBall.isPrototype && selectedBall.id === "CUSTOM" ? (
                <div>
                    <h5>Custom</h5>
                    <div ref={ballCustomInput}>
                        <input
                            id="customInputBall"
                            className="input"
                            type="text"
                            onChange={handleCustomBallChange}
                            />
                    </div>
                </div>
            ) :
            <div></div>}
            {/* <></>
            <div className='ball-series-checkbox-container'>
                <input
                    type="checkbox"
                    id="useSeriesCheckbox"
                    name="useSeriesCheckbox"
                    // disabled
                    onChange={handleBallSeriesCheck}
                    />
                <label htmlFor="useSeriesCheckbox">Use Series</label>
            </div> */}
            <></>
            {useBallSeries ? (
            <>
            <div className='ball-series-add-container' ref={ballSeriesContainer}>
                <input
                    type='text'
                    id="newSeriesInput"
                    className="input"
                    onKeyDown={handleBallSeriesAddEnter}
                    />
                <button
                    className='button'
                    style={{width:"100px"}}
                    onClick={handleBallSeriesAdd}>
                    Add Group
                </button>
            </div>
            <div style={{width:"100%", height:"400px"}}>
                <div className='ball-series-container'>
                    <DndContext sensors={sensors} collisionDetection={closestCenter} onDragEnd={handleBallSeriesDragEnd}>
                        <SortableContext items={ballSeries.map(item => item.id)} strategy={verticalListSortingStrategy}>
                            {ballSeries.map((item,index) => (
                                <SortableBallSeriesItem
                                    key={item.id}
                                    item={item}
                                    index={index}
                                    textAlign="center"
                                    onRename={handleBallSeriesRename}
                                    onDelete={handleBallSeriesDelete}
                                    DeleteSeriesIcon={DeleteSeriesIcon}
                                />
                            ))}
                        </SortableContext>
                    </DndContext>
                </div>
              </div>
            <div className='ball-series-num-series-container' ref={ballSeriesNumberInput}>
                <label htmlFor="numSeriesInput">Number of Series</label>
                <div>
                    <input
                        type="number"
                        id="numSeriesInput"
                        name="numSeriesInput"
                        className='input'
                        onChange={(e) => setBallSeriesCount(parseInt(e.target.value, 10) || 0)}
                        />
                </div>
            </div>
            </>
            ) : <div style={{height:'20px'}}></div>}
            <></>
            </div>
        
        {/* </Collapsible> */}
    </div>
    <div className="buttonContainer" style={{paddingBottom:"10px", paddingTop:"10px"}}>
        <button className="button" disabled={!validSetup} onClick={!useBallSeries ? createNewSetup : createNewSetupSeries}>Add</button>
        {/* <button className="button" onClick={() => handleModalClose()}>Close</button> */}
    </div>
</div>
    );
}


    return(
        <>
        {!isMobile && (
            <>
            {DesktopRender()}
            </>
        )}
        <></>
        {isMobile && (
            <>
            {MobileRender()}
            </>
        )}
        </>
    );
});

export default NewSetup;
